import $ from 'jquery';
import gsap from 'gsap';

export function addHeroContentAnimation(timeline, wrap, delay = 1, callback) {
	//console.log('addHeroContentAnimation', wrap);

	timeline
		.from(
			$(wrap).find('[data-i-hero-subtitle]'),
			{
				y: 70,

				duration: 1,
				opacity: 0,
				ease: 'power2.out',
			},
			delay,
		)
		.from(
			$(wrap).find('[data-i-hero-title]'),
			{
				y: 60,

				duration: 1,
				opacity: 0,
				ease: 'power2.out',
			},
			delay,
		)
		.from(
			$(wrap).find('[data-i-hero-text]'),
			{
				y: 50,

				duration: 1,
				opacity: 0,
				ease: 'power2.out',
			},
			delay,
		)
		.fromTo(
			$(wrap).find('[data-i-hero-btn]'),
			{
				y: 40,
				opacity: 0,
				pointerEvents: 'none',
			},
			{
				y: 0,

				duration: 1,
				opacity: 1,
				ease: 'power2.out',
				onComplete: () => {
					gsap.set($(wrap).find('[data-i-hero-btn]'), {
						pointerEvents: 'auto',
					});
					document.body.dispatchEvent(
						new CustomEvent('data-analytics', {
							detail:
								'2024-sia-'+(wrap == '[data-aisle-wrap]' ? 'aisle' : 'culinary')+'-' +
								(window.currentType === 'business' ? 'shanti' : 'etienne') +
								'-screenintro',
						}),
					);

					if (callback) callback();
				},
			},
			delay,
		)
		.fromTo(
			$(wrap).find('[data-i-hero-visuals]'),
			{
				y: 100,
				opacity: 0,
			},
			{
				y: 0,

				duration: 1,
				opacity: 1,
				ease: 'power2.out',
			},
			delay,
		);
}
